import * as React from "react";
import {IconButton, Tooltip} from "@mui/material";
import {GridViewOutlined, ViewListOutlined} from "@mui/icons-material";
import useDrive from "../../hooks/useDrive";
import {LAYOUTS} from "../../config/appConst";

export function LayoutSwitch() {
  const {layout, changeLayout} = useDrive();
  const isGrid = layout === LAYOUTS.GRID;

  return (
    <Tooltip title={isGrid ? "List view" : "Grid view"} arrow>
      <IconButton
        size="small"
        onClick={() => changeLayout(isGrid ? LAYOUTS.LIST : LAYOUTS.GRID)}
        sx={{
          width: 34, height: 34,
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: "8px",
          color: "var(--text-2)",
          "&:hover": { borderColor: "rgba(255,255,255,0.2)", color: "var(--text-1)", background: "rgba(255,255,255,0.05)" },
        }}
      >
        {isGrid
          ? <ViewListOutlined sx={{fontSize: 18}} />
          : <GridViewOutlined sx={{fontSize: 18}} />}
      </IconButton>
    </Tooltip>
  );
}
